import React, { useState } from "react";
import { connect } from "react-redux";
import { State } from "../../../state";
import { editTagAreaText } from "./actions";
import { getTagAreas } from "./selector";
import { EditTagText, TagArea } from "./types";

const MODES = {
  SELECT: "select",
  EDIT: "edit"
};

interface Props {
  tagAreas: TagArea[];
  areaId: string;
  isSelected: (areaId: string) => any;
  editTagAreaText: ({  }: EditTagText) => void;
  classes: string;
  handleOnClick: (areaId: string) => any;
  getOcr: (areaId: string) => any;
}

const TagCell = (props: Props) => {
  const { areaId, isSelected } = props;

  const tagArea = props.tagAreas.filter(area => area.areaId === areaId)[0];
  const initialText = tagArea ? tagArea.value : "";
  const [mode, setMode] = useState(MODES.SELECT);
  const [value, setValue] = useState(initialText);

  const handleDoubleClick = () => {
    if (tagArea && tagArea.areaId) {
      setMode(MODES.EDIT);
      setValue(tagArea.value);
    }
  };

  const handleBlur = event => {
    props.editTagAreaText({ areaId, value: event.target.value });
    setMode(MODES.SELECT);
  };

  const handleChange = event => {
    setValue(event.target.value);
  };

  if (mode === MODES.EDIT) {
    return (
      <input
        style={{ width: "100%" }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
      />
    );
  }

  return (
    <div
      className={`${props.classes} ${
        isSelected(areaId) ? "Tag__Area--selected" : ""
      }`}
      onClick={props.handleOnClick(areaId)}
      onDoubleClick={handleDoubleClick}
    >
      <div>{props.getOcr(areaId)}</div>
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  tagAreas: getTagAreas(state)
});

export default connect(
  mapStateToProps,
  {
    editTagAreaText
  }
)(TagCell);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/Tag/TagCell.tsx